import type { BagDetailCustomer } from '../types';

type Props = {
  customer: BagDetailCustomer | null;
};

const hasAddress = (customer: BagDetailCustomer): boolean =>
  !!(
    customer.street ||
    customer.city ||
    customer.state ||
    customer.cep
  );

export const BagAddress = ({ customer }: Props) => {
  if (!customer) {
    return (
      <p className="text-sm text-muted-foreground">Cliente excluído</p>
    );
  }

  if (!hasAddress(customer)) {
    return (
      <p className="text-sm text-muted-foreground">Endereço não cadastrado</p>
    );
  }

  const lines: string[] = [];

  const streetParts = [customer.street, customer.number, customer.complement]
    .filter(Boolean);
  if (streetParts.length > 0) lines.push(streetParts.join(', '));
  if (customer.neighborhood) lines.push(customer.neighborhood);

  const cityLine = [customer.city, customer.state]
    .filter(Boolean)
    .join('/');
  if (cityLine) lines.push(cityLine);
  if (customer.cep) lines.push(`CEP ${customer.cep}`);

  return (
    <address className="not-italic text-sm text-foreground flex flex-col gap-0.5">
      {lines.map((line, i) => (
        <span key={i}>{line}</span>
      ))}
    </address>
  );
};
